import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Image,
  Input,
  Modal,
  PaginationProps,
  Select,
  Table,
  TableColumnsType,
  Tabs,
  TabsProps,
  SelectProps,
  Row,
  Checkbox,
} from "antd";
import { ArrowSquareDown, Clock, Crown, SearchZoomIn1 } from "iconsax-react";
import "./AddPlayer.scss";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
// import tableData from '../playersTableData.json'
import { mixPostV1, mixGetV1 } from "../../../services/mixin";
import { IMAGE_URL } from "../../../env";
type LabelRender = SelectProps["labelRender"];

const customSelectedLabel: LabelRender = (props) => {
  const { label } = props;

  if (label) {
    return (
      <Flex align="center" gap={8}>
        <Crown size={20} variant="Bulk" style={{ minWidth: 20 }} />
        <span>
          Role (<span className="text-active">{label}</span>)
        </span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <Crown size={20} variant="Bulk" style={{ minWidth: 20 }} />
      <span>Role</span>
    </Flex>
  );
};
const fallbackAvatar =
  "data:image/png;base64,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";

interface Props {
  isShow?: boolean;
  players?: Array<any>;
  onPopupClose?: () => void;
  onAddPlayer?: (player: any) => void;
}

const closeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.86312 3.86363C4.03189 3.6949 4.26077 3.60012 4.49942 3.60012C4.73806 3.60012 4.96694 3.6949 5.13572 3.86363L8.99942 7.72733L12.8631 3.86363C12.9461 3.77767 13.0455 3.7091 13.1553 3.66194C13.2651 3.61477 13.3832 3.58994 13.5027 3.5889C13.6222 3.58786 13.7407 3.61063 13.8513 3.65589C13.9619 3.70114 14.0624 3.76797 14.1469 3.85247C14.2314 3.93697 14.2982 4.03746 14.3435 4.14807C14.3887 4.25867 14.4115 4.37719 14.4104 4.49669C14.4094 4.61619 14.3846 4.73429 14.3374 4.84409C14.2902 4.95389 14.2217 5.0532 14.1357 5.13623L10.272 8.99993L14.1357 12.8636C14.2997 13.0334 14.3904 13.2607 14.3883 13.4967C14.3863 13.7327 14.2916 13.9584 14.1248 14.1253C13.9579 14.2921 13.7322 14.3868 13.4962 14.3888C13.2602 14.3909 13.0329 14.3002 12.8631 14.1362L8.99942 10.2725L5.13572 14.1362C4.96598 14.3002 4.73863 14.3909 4.50266 14.3888C4.26668 14.3868 4.04095 14.2921 3.87408 14.1253C3.70721 13.9584 3.61256 13.7327 3.61051 13.4967C3.60846 13.2607 3.69918 13.0334 3.86312 12.8636L7.72682 8.99993L3.86312 5.13623C3.69439 4.96745 3.59961 4.73857 3.59961 4.49993C3.59961 4.26128 3.69439 4.0324 3.86312 3.86363Z"
      fill="#6B7280"
    />{" "}
  </svg>
);

interface DataType {
  key: React.Key;
  appId?: string;
  customerName?: string;
  customerPhone?: string;
  customerFace?: string;
  customerTimer?: string;
}

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const AddPlayerModal: React.FC<Props> = (props) => {
  const { isShow = false, players, onPopupClose, onAddPlayer } = props;
  const [open, setOpen] = useState(isShow);
  const [selectedPlayers, setSelectedPlayers] = useState([] as any);

  useEffect(() => {
    setOpen(isShow);

    if (isShow) {
      getItems();
      getLevels();

      const selected: any = [];
      const selectedId: any = [];
      // eslint-disable-next-line array-callback-return
      players?.map((item: any) => {
        selected.push(item);
        selectedId.push(item.id);
      });
      setSelectedPlayers(selected);
      setSelectedRowKeys(selectedId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);

  const onClose = () => {
    setOpen(false);
    if (onPopupClose) {
      onPopupClose();
    }
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: "App ID",
      dataIndex: "appId",
      key: "appId",
    },
    {
      title: "Customer name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Phone number",
      dataIndex: "customerPhone",
      key: "customerPhone",
    },
    {
      title: "Member Face",
      dataIndex: "customerFace",
      key: "customerFace",
      render: (text, record) => (
        <Flex align="center" gap={12}>
          {/* <img src={text} alt={record.customerName} className="avatar" /> */}
          {/* <Avatar size={40} src={text ? text : '/images/avatar/avatar1-40x40.png'}  /> */}
          <Image
            height={40}
            width={40}
            src={`${IMAGE_URL}${text}`}
            alt={record.customerName}
            preview={{
              src: `${IMAGE_URL}${text}`,
            }}
            fallback={fallbackAvatar}
            style={{ borderRadius: "50%", overflow: "hidden" }}
          />
          <span>{record.customerTimer}</span>
        </Flex>
      ),
    },
  ];

  // TABLE ROW SELECTION
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows: any
  ) => {
    let player = [...selectedPlayers];
    let rowKeys = [...selectedRowKeys];
    items.list.map((val: any) => {
      if (newSelectedRowKeys.includes(val.customer_id)) {
        const findData = player.find((x) => x.customer_id === val.customer_id);
        if (!findData) {
          player.push(val);
          rowKeys.push(val.customer_id);
        }
      } else {
        player = player.filter((x) => x.customer_id !== val.customer_id);
        rowKeys = rowKeys.filter((x) => x !== val.customer_id);
      }
      return true;
    });

    setSelectedRowKeys(rowKeys);
    setSelectedPlayers(player);
  };
  const rowSelection = {
    fixed: true,
    selectedRowKeys,
    columnWidth: 68,
    onChange: onSelectChange,
  };
  // END TABLE ROW SELECTION

  // ADD PLAYERS
  const [loading, setLoading] = useState(false);
  const addPlayer = () => {
    setLoading(true);
    const players: any = [];
    selectedPlayers.map((item: any) =>
      players.push({
        ...item,
        id: item.customer_id,
        name: item.customer_name,
        avatar: item.avatar || "/images/avatar/avatar1-40x40.png",
      })
    );

    setTimeout(() => {
      // setSelectedRowKeys([])
      setLoading(false);
      if (onAddPlayer) {
        onAddPlayer(players);
      }
    }, 1000);
  };
  // END ADD PLAYERS

  // GET PLAYERS
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchCustomerName?: string;
    searchCustomerPhone?: string;
    levels?: number | string;
    roleSearch?: number | string;
    searchShift?: number | string;
    searchKey?: number | string;
    tab?: number | string;
  }>({
    limit: 10,
    page_number: 1,
  });

  const getItems = async () => {
    setTableLoading(true);

    try {
      const apiParams = {
        ...params,
      } as any;
      if (!apiParams.levels) {
        delete apiParams.levels;
      }
      if (currentTab === "2" && apiParams.levels) {
        apiParams.levelSearch = apiParams.levels;
      }
      if (!apiParams.searchShift) {
        delete apiParams.searchShift;
      }
      let api = "/api/webAdmin/storeGameCustomer.php";
      if (currentTab === "2") {
        api = "/api/webAdmin/gListAllDistinctCustomerOfStore.php";
      }
      const res = await mixPostV1(api, apiParams);

      if (res.status === 1 || res.message === "success") {
        setTableLoading(false);
        const result: any = [];
        if (currentTab === "2") {
          res.data.map((item: any) =>
            result.push({
              ...item,
              customer_id: item.app_id,
              key: item.app_id,
              appId: item.app_id,
              customerName: item.customer_name,
              customerPhone: item.phone_number,
              customerFace: item.avatar,
              customerTimer: item.time_checkin,
            })
          );
        } else {
          res.data.map((item: any) =>
            result.push({
              ...item,
              key: item.customer_id,
              appId: item.customer_id,
              customerName: item.customer_name,
              customerPhone: item.phone_number,
              customerFace: item.avatar,
              customerTimer: item.time_checkin,
            })
          );
        }

        if (currentTab === "2") {
          setItems({
            list: result,
            total: res.total,
          });
        } else {
          setItems({
            list: result,
            total: res.totalRecord,
          });
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET PLAYERS

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [searchType, setSearchType] = useState("phone-number");
  const onSearch = (query: string) => {
    if (currentTab === "1") {
      if (searchType === "phone-number") {
        setParams({
          ...params,
          page_number: 1,
          searchCustomerPhone: query,
          searchCustomerName: "",
        });
      }
      if (searchType === "name") {
        setParams({
          ...params,
          page_number: 1,
          searchCustomerPhone: "",
          searchCustomerName: query,
        });
      }
    } else {
      setParams({
        ...params,
        page_number: 1,
        searchKey: query,
      });
    }
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };
  // END SEARCH

  // GET LEVELS
  const [levels, setLevels] = useState([] as any);
  const [lvVal, setlvVal] = useState("" as any);
  const getLevels = async () => {
    try {
      const res = await mixPostV1("/api/webAdmin/gComboLevelSetting.php", {});

      if (res.status === 1) {
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            value: item.level_name,
            label: item.level_name,
          })
        );
        result.sort((a: any, b: any) => a.value - b.value);
        setLevels(result);
      }
    } catch (error) {}
  };
  // END GET LEVELS

  // SHIFT CHANGE
  const [shiftTimeout, setShiftTimeout] = useState<any>(null);
  const onShiftFilter = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchShift: query,
    });
  };
  const onShiftEnter = (e: any) => {
    onShiftFilter(e.target.value);
  };
  const onShiftChange = (e: any) => {
    clearTimeout(shiftTimeout);
    const timeout = setTimeout(() => {
      onShiftFilter(e.target.value);
    }, 250);
    setShiftTimeout(timeout);
  };
  // END SHIFT CHANGE

  // TABS
  const [currentTab, setCurrentTab] = useState("1");
  const tabs: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">Check in</div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">All Member</div>
        </div>
      ),
    },
  ];
  const onTabChange = (key: string) => {
    setCurrentTab(key);
    setParams({ ...params, page_number: 1, tab: key });
    setSelectedPlayers([]);
    setSelectedRowKeys([]);
  };

  // GET USER ROLES
  const [rolesVal, setRolesVal] = useState("" as any);
  const [roles, setRoles] = useState([] as any);
  const getUserRoles = async () => {
    const res = await mixGetV1("/api/webAdmin/gComboRoleCustoomer.php", {});

    if (res.status === 1) {
      const result: any = [];

      res.data.map((item: any) =>
        result.push({
          ...item,
          value: item.role_id,
          label: item.role_name,
        })
      );

      setRoles(result);
    }
  };
  useEffect(() => {
    getUserRoles();
  }, []);

  const onRoleChange = (value: any) => {
    if (value) {
      setRolesVal(value);
      setParams({ ...params, page_number: 1, roleSearch: value });
    } else {
      setRolesVal("");
      setParams({ ...params, page_number: 1, roleSearch: "" });
    }
  };

  const onCheckAllChange = async (e: any) => {
    const checked = e.target.checked;
    if (checked) {
      setTableLoading(true);
      const apiParams = {
        ...params,
      } as any;
      if (!apiParams.levels) {
        delete apiParams.levels;
      }
      if (currentTab === "2" && apiParams.levels) {
        apiParams.levelSearch = apiParams.levels;
      }
      if (!apiParams.searchShift) {
        delete apiParams.searchShift;
      }
      let api = "/api/webAdmin/storeGameCustomerNolimit.php";
      if (currentTab === "2") {
        api = "/api/webAdmin/gListAllDistinctCustomerOfStoreNoLimit.php";
      }
      const res = await mixPostV1(api, apiParams);
      if (res?.status === 1) {
        let player: any = [];
        let rowKeys = res?.data?.map((item: any) => item.app_id);
        res?.data.map((item: any) =>
          player.push({
            ...item,
            customer_id: item.app_id,
          })
        );
        setSelectedRowKeys(rowKeys);
        setSelectedPlayers(player);
        setTableLoading(false);
      } else {
        setTableLoading(false);
      }
    } else {
      setSelectedRowKeys([]);
      setSelectedPlayers([]);
    }
  };

  return (
    <Modal
      centered
      open={open}
      closeIcon={closeIcon}
      footer={null}
      className="rs-modal add-player-modal"
      rootClassName="rs-modal-root"
      onCancel={onClose}
    >
      <div className="table-filter-block">
        <div className="left">
          <Select
            value={lvVal}
            placeholder="Level"
            options={levels}
            popupMatchSelectWidth={false}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            className="rs-select"
            popupClassName="rs-select-dropdown"
            allowClear={lvVal !== ""}
            labelRender={({ label }) => {
              return (
                <Flex align="center" gap={8}>
                  <Crown size={20} variant="Bulk" />
                  <span>{label ? label : "Level"}</span>
                </Flex>
              );
            }}
            onChange={(value) => {
              if (!value) {
                value = "";
              }
              setlvVal(value);
              setParams({ ...params, page_number: 1, levels: value });
            }}
          />
          {currentTab === "2" && (
            <Select
              defaultValue={""}
              options={roles}
              placeholder="Role"
              popupMatchSelectWidth={false}
              allowClear={rolesVal !== ""}
              suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
              // className="rs-select t-mw-290"
              className="rs-select w-186 grid-area-role"
              labelRender={customSelectedLabel}
              onChange={onRoleChange}
            />
          )}
          {currentTab === "1" && (
            <Input
              placeholder="Shift"
              allowClear
              prefix={<Clock size={20} variant="Bulk" />}
              className="rs-input w-120"
              type="Number"
              onPressEnter={(e) => onShiftEnter(e)}
              onChange={(e) => onShiftChange(e)}
            />
          )}
        </div>

        <div className="right">
          {currentTab === "2" && (
            <Input
              placeholder="Search by name, appid"
              prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
              className="rs-input w-349 grid-area-search"
              allowClear
              onPressEnter={(e) => onEnter(e)}
              onChange={(e) => onChange(e)}
            />
          )}
          {currentTab === "1" && (
            <Input
              placeholder="Search"
              prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
              allowClear
              addonAfter={
                <Select
                  value={searchType}
                  options={[
                    { value: "phone-number", label: "Phone Number" },
                    { value: "name", label: "Customer Name" },
                  ]}
                  suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                  popupMatchSelectWidth={false}
                  className="rs-select"
                  onChange={(value) => setSearchType(value)}
                />
              }
              className="rs-input search-group"
              onPressEnter={(e) => onEnter(e)}
              onChange={(e) => onChange(e)}
            />
          )}
          <Button
            loading={loading}
            disabled={selectedRowKeys.length === 0}
            className="rs-button light-outlined"
            onClick={addPlayer}
          >
            Add player{" "}
            {selectedRowKeys.length > 0 && `(${selectedRowKeys.length})`}
          </Button>
        </div>
      </div>

      <Tabs
        activeKey={currentTab}
        items={tabs}
        className="rs-tabs rs-tabs--no-tab-content"
        onChange={onTabChange}
      />
      <Row justify="end" style={{ marginBottom: 8 }}>
        <Checkbox
          indeterminate={false}
          onChange={onCheckAllChange}
          checked={selectedRowKeys.length === items.total}
          className="text t-fz-16"
          style={{ color: "white" }}
        >
          Select All
        </Checkbox>
      </Row>
      <Table
        columns={columns}
        dataSource={items.list}
        className="rs-table table-text-nowrap match-height"
        rowSelection={rowSelection}
        loading={tableLoading}
        scroll={{
          x: true,
        }}
        pagination={{
          pageSize: params.limit,
          position: ["bottomCenter"],
          showSizeChanger: true,
          showTitle: false,
          total: items.total,
          itemRender: customPrevNext,
          onChange: (e) => onPageChange(e),
        }}
        onChange={onTableChange}
      />
    </Modal>
  );
};

export default AddPlayerModal;
